import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyBE4R7w_z7p-1DoQmTRqITb2hG72BJrCQ4',
  authDomain: 'finpal-e7a76.firebaseapp.com',
  projectId: 'finpal-e7a76',
  storageBucket: 'finpal-e7a76.appspot.com',
  messagingSenderId: '51270370115',
  appId: '1:51270370115:web:2a64fb9f7dbb65c14da5f6',
  measurementId: 'G-P16DB5TDK4',
};

firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();

export default firebase;
